import EmergencyGuideBanner from '@/pages/home/components/EmergencyGuideBanner';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import TutorialList from '@/pages/quiero-cambiar/components/TutorialList';
import { cambiarSignals } from '@/mocks/quiero-cambiar';

export default function QuieroCambiar() {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      {/* Mercedes te da la bienvenida */}
      <section className="py-10 md:py-14 px-6 md:px-10 bg-white">
        <div className="w-full max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-10 items-center">
          <div className="relative rounded-xl overflow-hidden aspect-[4/3] max-w-xs md:max-w-none mx-auto md:mx-0">
            <img
              src="https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/cb48fa68-60e3-4ec2-a15e-560ba917e274_compressed_ChatGPT-Image-10-ago-2026-12_27_22-a.m.-1.webp"
              alt="Mercedes tomando té relajada"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex flex-col justify-center">
            <p className="font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.25em] mb-3">
              Un mensaje de Mercedes
            </p>
            <h2 className="font-serif text-2xl md:text-3xl font-bold text-[#8B6F5C] leading-tight mb-3">
              Hola, soy Mercedes
            </h2>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed mb-2">
              Te quiero contar algo nuevo para que empieces y te decidas a hacer un nuevo camino.
            </p>
            <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed">
              Sé lo que se siente cuando las noches se hacen largas y los consejos no alcanzan.
              Por eso quiero compartirte estas herramientas que pueden marcar la diferencia,
              desde hoy mismo.
            </p>
          </div>
        </div>
      </section>

      {/* Hero */}
      <section className="relative overflow-hidden bg-cream py-14 md:py-20 px-6 md:px-10">
        <div className="w-full max-w-4xl mx-auto">
          <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.25em] mb-5 bg-white px-4 py-1.5 rounded-full border border-sand/50">
            Quiero cambiar
          </span>
          <h1 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#8B6F5C] leading-[1.15] mb-3">
            El cambio no empieza cuando tu bebé duerme toda la noche.
          </h1>
          <p className="font-serif text-lg md:text-xl lg:text-2xl text-terracotta italic leading-snug mb-8">
            Empieza cuando comprendés qué está necesitando.
          </p>

          <div className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
            <p className="mb-4">Tal vez llegaste hasta acá porque estás cansada.</p>
            <p className="mb-4">
              Cansada de probar consejos diferentes. De buscar respuestas a las tres de la mañana.
              De preguntarte por qué algo que funcionó ayer hoy parece no funcionar.
            </p>
            <p className="mb-4">
              Quizás tu bebé se despierta una y otra vez. Tal vez le cuesta conciliar el sueño,
              solamente logra dormirse de una determinada manera o sentís que cada noche se
              convirtió en una negociación agotadora.
            </p>
            <p className="mb-4">
              Y entre tantos consejos, métodos, opiniones y comparaciones aparece una pregunta que
              muchas mamás terminan haciéndose:
            </p>
            <p className="font-serif text-xl md:text-2xl font-bold text-[#4A3F35] italic mb-4">
              ¿Qué estoy haciendo mal?
            </p>
            <p className="font-medium">
              En NeuroBabys queremos empezar por otro lugar. No queremos enseñarte a controlar el
              sueño de tu bebé. Queremos ayudarte a comprenderlo.
            </p>
          </div>
        </div>
      </section>

      {/* No necesitás cambiar a tu bebé */}
      <section className="py-12 md:py-16 px-6 md:px-10 bg-white">
        <div className="w-full max-w-4xl mx-auto">
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#8B6F5C] leading-tight mb-2">
            No necesitás cambiar a tu bebé
          </h2>
          <p className="font-serif text-lg md:text-xl text-terracotta italic mb-6">
            Necesitás comprender mejor lo que está ocurriendo.
          </p>

          <div className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
            <p className="mb-3">
              El sueño infantil no es algo fijo. Cambia junto con el cerebro, el cuerpo, las
              emociones y el desarrollo del bebé.
            </p>
            <p className="mb-3">
              Por eso una rutina puede funcionar durante un tiempo y después necesitar ajustes.
            </p>
            <p className="mb-3">
              Un despertar puede significar sueño, hambre, necesidad de contacto, incomodidad,
              sobreestimulación o simplemente una nueva etapa del desarrollo.
            </p>
            <p className="mb-3">
              Cuando no entendemos esas señales, aparece la frustración. Cuando empezamos a
              reconocerlas, podemos responder de otra manera.
            </p>
            <p className="mb-6">Ese es el punto de partida de NeuroBabys:</p>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch gap-2 md:gap-3">
            {['Comprender', 'Acompañar', 'Transformar'].map((pill, index) => (
              <div
                key={pill}
                className="flex-1 flex items-center justify-center gap-2 bg-cream border border-sand/50 rounded-full px-5 py-3"
              >
                <span className="font-serif text-base md:text-lg font-bold text-[#8B6F5C]">
                  {pill}
                </span>
                {index < 2 && (
                  <span className="font-sans text-terracotta text-base font-semibold">·</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tal vez sea momento de cambiar si... */}
      <section className="py-10 md:py-12 px-6 md:px-10 bg-sand">
        <div className="w-full max-w-5xl mx-auto">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight text-center mb-6 md:mb-8">
            Tal vez sea momento de cambiar si...
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-2 mb-5">
            {cambiarSignals.map((signal) => (
              <div key={signal} className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-terracotta text-lg" />
                </div>
                <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
                  {signal}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center max-w-2xl mx-auto">
            <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-1">
              Si te reconocés en algunas de estas situaciones, no necesitás cambiar todo de golpe.
            </p>
            <p className="font-sans text-base text-[#3D2B1F] leading-relaxed">
              Necesitás encontrar un punto desde donde empezar. Y queremos ayudarte a encontrarlo.
            </p>
          </div>
        </div>
      </section>

      {/* Antes de pedirte que compres algo */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full">
          <h2 className="font-serif text-lg md:text-xl lg:text-2xl font-bold text-[#8B6F5C] leading-tight mb-6">
            Antes de pedirte que adquieras algún contenido, queremos ayudarte
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
            En NeuroBabys creemos que primero tenés que poder conocer nuestra manera de trabajar.
            Por eso creamos una serie de tutoriales gratuitos, breves y prácticos que podés comenzar
            a utilizar ahora mismo.
          </p>
          <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
            No necesitás registrarte en un programa completo para empezar a aprender. Elegí
            simplemente el tema que más se parece a lo que estás viviendo hoy.
          </p>
          <p className="font-sans text-base text-[#3D2B1F] leading-relaxed font-medium">
            Mirá. Probá. Observá. Y descubrí si esta manera de acompañar a tu bebé también puede
            ayudarte a vos.
          </p>
        </div>
      </section>

      {/* Empezá gratis — Tutoriales */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.25em] mb-4">
              Tutoriales gratuitos
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight">
              Empezá gratis
            </h2>
          </div>

          <TutorialList />

          <div className="mt-10 md:mt-12">
            <EmergencyGuideBanner variant="gratis" />
          </div>
        </div>
      </section>



      {/* No tenés que hacer todo hoy */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-10 items-center">
          <div className="relative rounded-xl overflow-hidden aspect-[4/3] max-w-xs md:max-w-none mx-auto md:mx-0">
            <img
              src="https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/0ce28765-7cb5-468e-b63e-47d7018eec7a_compressed_ChatGPT-Image-10-ago-2026-12_30_22-a.m.-1.webp"
              alt="Mercedes meditando con mano en el pecho"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#8B6F5C] leading-tight mb-4">
              No tenés que hacer todo hoy
            </h2>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed mb-3">
              Elegí solamente una herramienta. Probala. Observá a tu bebé. Observate también a vos.
            </p>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed mb-3">
              Y prestá atención a algo muy importante: qué cambia cuando empezás a comprender antes de
              reaccionar.
            </p>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed mb-4">
              Porque muchas veces el primer cambio no ocurre en el sueño. Ocurre cuando dejás de
              sentir que estás improvisando. Cuando empezás a entender una señal. Cuando anticipás una
              situación. Cuando sabés por qué estás haciendo algo. Cuando recuperás un poco de
              seguridad.
            </p>
            <p className="font-serif text-lg md:text-xl lg:text-2xl font-bold text-[#4A3F35] italic leading-relaxed">
              Soy Mercedes y voy a estar siempre acompañándote en todo este nuevo camino.
            </p>
          </div>
        </div>
      </section>





      {/* Cierre */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-3xl mx-auto text-center">
          <p className="font-serif text-3xl font-semibold text-[#8B6F5C] mb-3">NeuroBabys</p>
          <p className="font-sans text-sm font-semibold text-terracotta uppercase tracking-[0.2em] mb-2">
            Conocimiento · Comprensión · Acompañamiento · Transformación
          </p>
          <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed">
            Una colección para toda la infancia. Un camino para toda la vida.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}